import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";
import { Box, CircularProgress } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { useAppDispatch } from "../redux/hook";
import { fetchProjectEdit } from "../redux/actions/projectAction";
import { getVideoId } from "../utils/utils";
import Projects from "./projects";

import "react-modal-video/css/modal-video.css";

export default function ProjectDetail({ id }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [isOpen, setOpen] = useState(false);
  const [projectData, setProjectData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id > 0) {
      const loadProject = async () => {
        const project = await dispatch(fetchProjectEdit({ id }));
        if (
          typeof project.payload === "string" ||
          project.payload === undefined
        ) {
          setLoading(false);
          // navigate(checkError(homeEdit.payload));
        } else {
          setLoading(false);
          setProjectData(project.payload);
        }
      };
      loadProject();
    } else {
      setLoading(false);
    }
  }, [dispatch, id]);

  const video = useCallback(() => {
    if (projectData.video !== undefined) {
      return (
        <ModalVideo
          channel="youtube"
          youtube={{ mute: 0, autoplay: 0 }}
          isOpen={isOpen}
          videoId={getVideoId(projectData.video)}
          onClose={() => setOpen(false)}
        />
      );
    }
  }, [projectData.video, isOpen]);

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return id > 0 ? (
    <section className="relative md:py-24 py-16">
      <div className="container relative">
        <div className="md:flex justify-center mt-6">
          <div className="lg:w-full">
            <div className="relative">
              <img
                src={
                  process.env.REACT_APP_API_URL +
                  "/wwwroot/images/" +
                  projectData?.image_file_04
                }
                className="rounded-xl shadow-md dark:shadow-gray-800"
                alt=""
              />
              <div className="absolute bottom-2/4 translate-y-2/4 start-0 end-0 text-center">
                <Link
                  to="#!"
                  onClick={() => setOpen(true)}
                  className="lightbox h-20 w-20 rounded-full shadow-lg shadow-slate-100 dark:shadow-slate-800 inline-flex items-center justify-center bg-white dark:bg-slate-900 text-orange-600"
                >
                  <i className="mdi mdi-play inline-flex items-center justify-center text-2xl"></i>
                </Link>
              </div>
              {video()}
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-12 grid-cols-1 gap-6 mt-6">
          <div className="lg:col-span-5 md:col-span-6">
            <div className="grid grid-cols-1 gap-6">
              <img
                src={
                  process.env.REACT_APP_API_URL +
                  "/wwwroot/images/" +
                  projectData.image_file
                }
                className="rounded-xl"
                alt=""
              />
              <img
                src={
                  process.env.REACT_APP_API_URL +
                  "/wwwroot/images/" +
                  projectData.image_file_02
                }
                className="rounded-xl"
                alt=""
              />
              <img
                src={
                  process.env.REACT_APP_API_URL +
                  "/wwwroot/images/" +
                  projectData.image_file_03
                }
                className="rounded-xl"
                alt=""
              />
            </div>
          </div>

          <div className="lg:col-span-7 md:col-span-6">
            <div className="sticky top-20">
              <div className="grid lg:grid-cols-12 grid-cols-1 gap-6">
                <div className="lg:col-span-12">
                  <div className="work-details">
                    <h4 className="text-xl font-semibold mb-3 border-b border-gray-100 dark:border-gray-700 pb-3">
                      {t("external.project.project")}: {projectData.name}
                    </h4>
                    <p
                      className="text-slate-400 dark:text-white/60"
                      dangerouslySetInnerHTML={{
                        __html: projectData.description_internal,
                      }}
                    ></p>
                  </div>
                </div>

                <div className="lg:col-span-7">
                  <div className="bg-gray-50 dark:bg-slate-800 shadow dark:shadow-gray-800 p-6 rounded-xl">
                    <h5 className="text-lg font-semibold border-b border-gray-100 dark:border-gray-700 pb-3 mb-3">
                      {t("external.project.information_project")} :
                    </h5>
                    <dl className="grid grid-cols-12 mb-0">
                      <dt className="md:col-span-4 col-span-5 mt-2">
                        {t("external.project.responsible")} :
                      </dt>
                      <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                        {projectData.name_responsible}
                      </dd>

                      <dt className="md:col-span-4 col-span-5 mt-2">
                        {t("external.project.position")} :
                      </dt>
                      <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                        {projectData.position}
                      </dd>

                      <dt className="md:col-span-4 col-span-5 mt-2">
                        {t("external.project.start_date")} :
                      </dt>
                      <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                        {moment(projectData?.start).format("DD/MM/YYYY")}
                      </dd>

                      <dt className="md:col-span-4 col-span-5 mt-2">
                        {t("external.project.contact")} :
                      </dt>
                      <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                        {projectData.contact}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <Projects />
  );
}
